import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const ManageBuy = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [filterparams, setFilterparams] = useState({});
  const [posttype, setPosttype] = useState('');

  const { sendNetworkRequest } = React.useContext(NetworkContext);
 function onSearch(searchtext)
{
  setFilterparams({
    ...filterparams,
    searchtext: searchtext
  })
  fetchallposts({
    ...filterparams,
    searchtext: searchtext
  });
}
  async function fetchallposts(filtercontent)
  {
    let products = await sendNetworkRequest('/getbuysell', {}, filtercontent,false)
    
    setOrders(products)
  }  
  useEffect(() => {
    const post_type = props.location.pathname.split('/')[2];
    setPosttype(post_type)
    setFilterparams({
      ...filterparams,
      posttype: post_type
    })
    fetchallposts({
      ...filterparams,
      posttype : post_type
    })
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header post_type = {posttype}/>
       <SearchBar onSearch={onSearch}/> 
      <Results
        className={classes.results}
        orders={orders} //
      />
     
    </Page>
  );
});

export default ManageBuy;
